import { TypographyProps } from '@components/Typography';
import styled from 'styled-components';

export const FooterRootContainer = styled.div`
  background-color: #f5f5f5;
  font-family: proxima-nova, sans-serif;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    margin-top: 0rem;
    padding: 3rem 1rem;
  }
`;

export const FooterContainer = styled.div`
  max-width: 1426px;
  margin: 0 auto;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 2rem;

  font-size: ${(props: TypographyProps) => props.theme.fontSize.size18};

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    font-size: ${(props: TypographyProps) => props.theme.fontSize.size16};
  }
`;

export const FooterContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;

  border-bottom: 1px solid ${({ theme }) => theme.color.greyMedium};

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    grid-template-columns: 1fr;
  }
`;

export const FooterLinksContainer = styled.footer`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1.25rem;
  padding-top: 3rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    grid-template-columns: 1fr;
    gap: 1.875rem;
    padding: 0;
  }
`;

export const Logo = styled.img`
  max-width: 300px;
  margin-bottom: 0.625rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    justify-content: left;
    max-width: 170px;
  }
`;

export const CompanyDescriptionContainer = styled.div`
  display: flex;
  justify-content: left;
  position: relative;
  top: -2.5rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    justify-content: start;
  }
`;

export const CompanyDescription = styled.p`
  color: ${(props: TypographyProps) => props.theme.color.mobilityGrey};
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size18};
  max-width: 286px;
  padding-left: 1.25rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    font-size: ${(props: TypographyProps) => props.theme.fontSize.size16};
    padding-left: 0rem;
    max-width: 100%;
  }
`;

export const Column = styled.div`
  padding-top: 3.125rem;
  text-align: left;
  padding-bottom: 1.875rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    border-bottom: 2px solid ${({ theme }) => theme.color.white};
    padding-top: 0;
    padding-bottom: 2rem;

    &[data-section='what-we-do'],
    &[data-section='the-company'] {
      display: block;
    }

    &[data-section='what-we-do'] .link-items-inline,
    &[data-section='the-company'] .link-items-inline {
      display: inline;
      white-space: normal;
      line-height: 1.6;
    }
  }
`;

export const ColumnLogo = styled.div`
  text-align: left;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    border-bottom: 2px solid ${({ theme }) => theme.color.white};
    margin-bottom: 1.9375rem;
    text-align: left;
  }
`;

export const ColumnTitle = styled.h4`
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size20};
  font-weight: bold;
  padding-bottom: 1rem;
  color: ${(props: TypographyProps) => props.theme.color.mobilityGrey};

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    font-size: ${(props: TypographyProps) => props.theme.fontSize.size18};
  }
`;

export const SocialLinkColumnTitle = styled.h4`
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size20};
  font-weight: bold;
  margin-bottom: 2rem;
  color: ${(props: TypographyProps) => props.theme.color.mobilityGrey};

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    font-size: ${(props: TypographyProps) => props.theme.fontSize.size18};
    margin-top: 2rem;
    text-align: left;
  }
`;

export const LinkItem = styled.p`
  cursor: pointer;
  color: ${(props: TypographyProps) => props.theme.color.mobilityGrey};
  padding-bottom: 1.25rem;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    ${Column}[data-section='what-we-do'] &,
    ${Column}[data-section='the-company'] & {
      display: inline;
      margin-right: 0.25rem;

      &::after {
        content: ' • ';
        margin-left: 0.25rem;
      }

      &:last-child::after {
        content: '';
      }
    }
  }
`;

export const ContactInfo = styled.p`
  display: flex;
  gap: 1rem;
  padding-bottom: 1rem;
  color: ${(props: TypographyProps) => props.theme.color.mobilityGrey};
`;

export const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 4rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    text-align: left;
    justify-content: start;
    width: 100%;
    margin-bottom: 4rem;
  }
`;

export const TermsAndCopyrightsContainer = styled.div`
  color: ${({ theme }) => theme.color.mobilityGrey};
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: start;
  padding: 2.5rem 0;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-direction: column-reverse;
    align-items: start;
    row-gap: 2rem;
    padding-bottom: 6rem;
  }
`;

export const OptionsContainer = styled.div`
  display: flex;
  gap: 2rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-flow: wrap;
    row-gap: 0rem;
    column-gap: 1rem;
  }
`;

export const FootNoteOption = styled.span`
  cursor: pointer;

  @media (max-width: ${({ theme }) => theme.breakpoint.width480}) {
    font-size: 13px;
  }
`;

export const CopyrightText = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-direction: column;
    padding-top: 1.9375rem;
    text-align: left;
  }
`;

export const NewsletterSection = styled.div`
  background-color: ${({ theme }) => theme.color.primary};
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  justify-content: center;
  width: 80%;
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    padding: 1.5rem;
  }
`;

export const NewsletterContent = styled.div`
  flex: 1;
`;

export const NewsletterTitle = styled.h3`
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size24};
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: white;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    font-size: ${(props: TypographyProps) => props.theme.fontSize.size20};
  }
`;

export const NewsletterSubtitle = styled.p`
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size16};
  margin-bottom: 0.25rem;
  color: white;
  opacity: 0.9;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    font-size: ${(props: TypographyProps) => props.theme.fontSize.size14};
  }
`;

export const NewsletterTextLine = styled.div`
  font-family: ${'Lato, Arial, sans-serif'};
  display: flex;
  align-items: baseline;
  margin-bottom: 0.25rem;
  color: white;
  line-height: 1.5rem;
  font-size: 1.8rem;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const NewsletterTextLineLite = styled.div`
  font-family: ${'Lato, Arial, sans-serif'};
  display: flex;
  align-items: baseline;
  margin-bottom: 0.25rem;
  margin-top: 1rem;
  color: white;
  font-size: 1.2rem;
  line-height: 1.2rem;
  font-weight: 300;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const NewsletterHighlightedText = styled.span`
  font-family: ${'Lato, Arial, sans-serif'};
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size20};
  font-weight: bold;
  color: white;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    font-size: ${(props: TypographyProps) => props.theme.fontSize.size18};
  }
  margin-right: 0.25rem;
`;

export const NewsletterRegularText = styled.span`
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size16};
  font-weight: normal;
  color: white;
  opacity: 0.9;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    font-size: ${(props: TypographyProps) => props.theme.fontSize.size14};
  }
`;

export const NewsletterForm = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-direction: column;
    width: 100%;
    gap: 0.75rem;
  }
`;

export const NewsletterFormContainer = styled.div`
  background-color: white;
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  padding: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    flex-direction: column;
    width: 100%;
    gap: 0.5rem;
  }
`;

export const NewsletterInput = styled.input`
  padding: 0.75rem 1rem;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size16};
  min-width: 250px;
  color: ${({ theme }) => theme.color.black};
  background-color: transparent;

  &::placeholder {
    color: ${({ theme }) => theme.color.mobilityGrey};
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    min-width: 100%;
    width: 100%;
  }
`;

export const NewsletterButton = styled.button`
  background-color: ${({ theme }) => theme.color.primary};
  color: ${({ theme }) => theme.color.white};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.radius5};
  padding: 0.75rem 1.5rem;
  font-size: ${(props: TypographyProps) => props.theme.fontSize.size16};
  font-weight: bold;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.width768}) {
    width: 100%;
  }
`;
